module.exports = __webpack_public_path__ + "img/text.852a3c54.png";